import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import Button from "../../../components/shared/buttons/button";
import {
  useCreateBrokerageBoxesDataMutation,
  useUpdateBrokerageBoxesPackedMutation,
} from "../materialEntered/materialApi";
import useTranslator from "../../../hooks/useTranslator";

export const PackedBoxModal = ({ show, setShow, record, mode, editMode ,lot_number_id }) => {
  // Translation
  
  const { _t } = useTranslator();

  // RTK Query
  const [createData, { isLoading: isCreating }] =
    useCreateBrokerageBoxesDataMutation();
  const [updateData, { isLoading: isUpdating }] =
    useUpdateBrokerageBoxesPackedMutation();

  // Initial State
  const initialFormData = {
    prime_type_one: "",
    prime_type_two: "",
    prime_lite_type_two: "",
    piece_type_two: "",
    total_pallets: "",
    type: mode,
    lot_number_id : lot_number_id
  };

  // States
  const [formData, setFormData] = useState(initialFormData);

  // Effects
  useEffect(() => {
    if (editMode === "edit" && record?.length > 0) {
      const recordObj = record[0];
      const updatedFormData = { ...initialFormData };
      for (const key in recordObj) {
        if (key in initialFormData) {
          updatedFormData[key] = recordObj[key];
        }
      }
      setFormData(updatedFormData);
    } else {
      setFormData(initialFormData);
    }
  }, [mode, record, show]);

  useEffect(() => {
    const handler = setTimeout(() => {
      const totalBoxesPacked =
        (Number(formData.prime_type_one) || 0) +
        (Number(formData.prime_type_two) || 0) +
        (Number(formData.prime_lite_type_two) || 0) +
        (Number(formData.piece_type_two) || 0);

      const totalPallets = Math.ceil(totalBoxesPacked / 80);
      setFormData((prev) => ({
        ...prev,
        total_pallets: totalPallets,
      }));
    }, 400);
    return () => clearTimeout(handler);
  }, [
    formData.prime_type_one,
    formData.prime_type_two,
    formData.prime_lite_type_two,
    formData.piece_type_two,
  ]);

  const handleClose = () => {
    setShow(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isCreating || isUpdating) {
      return false;
    }

    let updatedFormData = { ...formData };

    updatedFormData = {
      ...updatedFormData,
      prime_type_one: parseInt(updatedFormData.prime_type_one) || 0,
      prime_type_two: parseInt(updatedFormData.prime_type_two) || 0,
      prime_lite_type_two: parseInt(updatedFormData.prime_lite_type_two) || 0,
      piece_type_two: parseInt(updatedFormData.piece_type_two) || 0,
      total_pallets: parseInt(updatedFormData.total_pallets) || 0,
    };

    const mutation = editMode === "add" ? createData : updateData;

    try {
      const payload =
        editMode === "add"
          ? updatedFormData
          : { id: record[0].id, requestBody: updatedFormData };
      await mutation(payload).unwrap();
      handleClose();
    } catch (error) {
      console.error("Error creating/updating manager:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // Allow only digits (no decimals or minus signs)
    if (/^\d*$/.test(value)) {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const renderFormFields = () => {
    return (
      <>
        {mode === "piece" && (
          <>
            <Col lg={6}>
              <InputWithLabel
                label={_t('packing_batch_code',"Packing batch code")}
                type="number"
                name="lot_number_id"
                value={formData.lot_number_id}
                onChange={handleChange}
                placeholder={"0"}
                disabled={true}
              />
            </Col>
            <Col lg={6}>
              <InputWithLabel
                label={"Piece 20 pounds"}
                type="number"
                name="piece_type_two"
                value={formData.piece_type_two}
                onChange={handleChange}
                placeholder={"0"}
              />
            </Col>
          </>
        )}
        {mode !== "piece" && (
          <>
            <Col lg={6}>
              <InputWithLabel
                label={_t('packing_batch_code',"Packing batch code")}
                type="number"
                name="lot_number_id"
                value={formData.lot_number_id}
                onChange={handleChange}
                placeholder={"0"}
                disabled={true}
              />
            </Col>
            <Col lg={6}>
              <InputWithLabel
                label={"Prime 10 pounds"}
                type="number"
                name="prime_type_one"
                value={formData.prime_type_one}
                onChange={handleChange}
                placeholder={"0"}
              />
            </Col>
            <Col lg={6}>
              <InputWithLabel
                label={"Prime 20 pounds"}
                type="number"
                name="prime_type_two"
                value={formData.prime_type_two}
                onChange={handleChange}
                placeholder={"0"}
              />
            </Col>
            <Col lg={6}>
              <InputWithLabel
                label={"Seconds 20 pounds"}
                type="number"
                name="prime_lite_type_two"
                value={formData.prime_lite_type_two}
                onChange={handleChange}
                placeholder={"0"}
              />
            </Col>
          </>
        )}
        <Col lg={6}>
          <InputWithLabel
            label={"Total Pallets Ready"}
            type="number"
            name="total_pallets"
            value={formData.total_pallets}
            placeholder={"0"}
            disabled={true} // Disabled to prevent manual entry
          />
        </Col>
      </>
    );
  };

  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={
        mode === "cheek"
          ? _t("cCheeks_boxes_packed", "Cheeks Boxes Packed")
          : mode === ""
          ? _t("strips_boxes_packed", "Strips Boxes Packed")
          : _t("pieces_boxes_packed", "Pieces Boxes Packed")
      }
      children={formData}
    >
      <Row>{renderFormFields()}</Row>
      <Row>
        <Col className="text-end">
          <Button
            label={_t("save_changes", "Save Changes")}
            size="small"
            onClick={handleSubmit}
            disabled={isCreating || isUpdating}
          />
        </Col>
      </Row>
    </CommonModal>
  );
};
